import React, { forwardRef, useMemo } from "react";
import { FieldTypes } from "utils/formUtils";
import { urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import SentinelOneMappingForm from "./SentinelOneMappingForm";

function SentinelOneCredentialsForm(props, ref) {
  const fields = useMemo(() => {
    return [
      {
        name: "apiEndPoint",
        label: "API Endpoint",
        required: true,
        rules: [urlRegexValidator],
      },
      {
        name: "apiToken",
        label: "Api Token",
        required: true,
        type: FieldTypes.PASSWORD,
      },
    ];
  }, []);

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={SentinelOneMappingForm}
      initialValue={{ apiEndPoint: "https://<sentinelone-instance-region>.sentinelone.net" }}
    />
  );
}

export default forwardRef(SentinelOneCredentialsForm);
